// extracted by mini-css-extract-plugin
export default {"main_image":"Main_main_image__M0ilS","cloudMove":"Main_cloudMove__B8Q43","contentCardArea":"Main_contentCardArea__WToDF","subContent":"Main_subContent__oKvzS"};